import type { FC } from 'react'

import { DragOverlay } from '@dnd-kit/core'

import { Cue } from './Cue'
import { useDraggingCue } from './cue-dnd.store'

/**
 * The cue that follows the pointer during a drag.
 *
 * A custom overlay, so the row in the list is hidden rather than moved (see
 * `CueDraggable`).
 */
export const CueDragOverlay: FC = () => {
  const draggingCue = useDraggingCue()

  return (
    <DragOverlay>{draggingCue && <Cue cueId={draggingCue.id} />}</DragOverlay>
  )
}
